import pigPriceCategoryApi from "@/api/pig-price/pigPriceCategoryApi";

export default {
  namespaced: true,
  state: {
    calendar: {},
    prices: {}
  },
  mutations: {
    setCalendar(state, data) {
      state.calendar = data;
    },
    setPrices(state, data) {
      state.prices = data;
    }
  },
  actions: {
    async fetchAll({dispatch, commit}) {
      try {
        const response = await pigPriceCategoryApi.fetchAll();
        commit('setPrices', response.data);
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    },
    async fetchCategories({dispatch}) {
      try {
        const response = await pigPriceCategoryApi.fetchCategories();
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    },
    async fetchCalendar({dispatch, commit}) {
      try {
        const response = await pigPriceCategoryApi.fetchCalendar();
        commit('setCalendar', response.data);
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, { root: true});
      }
    }
  }
}
